import React, { Fragment, useEffect, useState } from "react";
import theme from '../../components/shared/theme';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, LinearProgress, MenuItem, Radio, RadioGroup, Select } from "@material-ui/core";
import {
    Clear as ClearIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    AccessTimeOutlined as TimeIcon,
} from '@material-ui/icons';
import { Controller, useForm } from "react-hook-form";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import api from "../../store/api";
import { Alert } from "@material-ui/lab";
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoIcon from '@material-ui/icons/Info';
import { forEach } from "lodash";
import TimeInput from "../ui/TimeInput";

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minWidth: 500,
        margin: 0,
        borderRadius: 0,
        shadow: 'none',
        backgroundColor: '#fff',
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    alertRoot: {
        marginTop: 24
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#303030',
        fontSize: 16,
        fontWeight: 900,
        padding: '16px 18px',
        '& .closeIcon': {
            height: '20px',
            width: '20px',
            fill: '#00152E',
            cursor: 'pointer',
        },
    },
    dialogContent: {
        padding: '11px 18px',
        marginBottom: '6px',
        overflowY: 'visible',
        '& .formContainer': {
            '& .etaFields': {
                padding: '5px 0px',
                paddingLeft: '36px',
                marginBottom: '14px',
            },
        },
    },
    dialogActions: {
        padding: '16px 18px',
    },
    textFieldInput: {
        height: '44px',
        width: '100%',
        backgroundColor: '#E8E8E8',
        color: '#303030',
        fontSize: 16,
        fontWeight: 500,
        borderRadius: '4px',
        padding: '12px',
    },
    selectField: {
        height: "44px",
        width: "100%",
        fontSize: 16,
        fontWeight: 500,
        backgroundColor: '#E8E8E8',
        color: '#303030',
        borderRadius: '4px',
        '& .MuiSelect-selectMenu': {
            fontWeight: 500,
        },
    },
    radioInput: {
        '& .radioOption': {
            color: '#303030',
            fontSize: 16,
            fontWeight: 500,
            "& svg": {
                color: 'black',
                fill: 'black',
            },
        },
    },
    button: {
        width: '100%',
        fontSize: 18,
        fontWeight: 400,
        borderRadius: '6px',
        padding: '8px',
        '&.cancelBtn': {
            backgroundColor: '#fff',
            color: '#02489D',
            border: '1px solid #02489D',
        },
        '&.submitBtn': {
            backgroundColor: '#02489D',
            color: '#FFFFFF',
        },
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

interface WeekDate {
    selected: boolean;
    name: string;
    date: string;
}

const CreateLoadingLine = (props: any): JSX.Element => {
    const classes = useStyles();
    return (
        <div className={classes.loading}>
            <LinearProgress color="primary" />
        </div>
    )
}

const weekDay = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const calculateDate = () => {
    let _tempDate = new Date();
    let dateUtils = new DateFnsUtils();
    let dates: WeekDate[] = [];
    for (let date = 0; date <= 1; date++) {
        let datebody: WeekDate = {
            selected: date === 0 ? true : false,
            name: date === 0 ? "Today" : date === 1 ? "Tomorrow" : weekDay[_tempDate.getDay()],
            date: dateUtils.format(_tempDate, "yyyy-MM-dd"),
        };
        dates.push(datebody);
        _tempDate.setDate(_tempDate.getDate() + 1);
    }
    return dates;
};

const ETAPopup = (props: any): JSX.Element => {
    const { open, onClose, etaTime, setetaTime, transferid, transferLoadingData, getScheduleTransferDetails } = props
    const classes = useStyles();
    const [days, setDays] = useState<WeekDate[]>(calculateDate());
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [eta, setETA] = useState("");
    const dateUtil = new DateFnsUtils();
    const [ETADay, setETADay] = useState(dateUtil.format(new Date(), "yyyy-MM-dd"));
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { handleSubmit, control, errors, getValues, setValue } = useForm();
    useEffect(() => {
        if (open) {
            setValue('showETA', transferLoadingData?.showETA == true ? "1" : "2");
            if (transferLoadingData?.eta) {
                const etaDate = new Date(transferLoadingData.eta);
                const dateUtils = new DateFnsUtils();
                setValue('etaTime', etaDate);
                setValue('etaDay', dateUtils.format(etaDate, "yyyy-MM-dd"));
                setETA(String(etaDate))
                let date = dateUtils.format(etaDate, "yyyy-MM-dd");
                setETADay(date)
            }
            else{
                setETADay(dateUtil.format(new Date(), "yyyy-MM-dd"));
            }
        }
        setIsSubmitting(false);
    }, [open, transferLoadingData, setValue,setETA,setETADay]);

    const onSubmit = async () => {
        try {
            setIsSubmitting(true);
            setLoading(true);
            setErrorMessage("");
            const data = getValues()
            const showETA = data?.showETA == "1" ? true : false;

            let request = {};
            let _etaTime : any = '';
            if (data?.showETA != '2') {

                const selectedHours = String(new Date(data?.etaTime).getHours());
                const selectedMinutes = String(new Date(data?.etaTime).getMinutes());
                _etaTime = (selectedHours.length > 1 ? selectedHours : '0' + selectedHours) + ':' + (selectedMinutes.length > 1 ? selectedMinutes : '0' + selectedMinutes)


                let ETAHr = new Date(data?.etaTime).getHours();
                let ETAMin = new Date(data?.etaTime).getMinutes();
                let ETASec = new Date(data?.etaTime).getSeconds();

                let etadateTime = new Date(data?.etaDay)
                etadateTime.setHours(ETAHr)
                etadateTime.setMinutes(ETAMin)
                etadateTime.setSeconds(ETASec)

                const dateUtils = new DateFnsUtils();
                let formattedETADate = dateUtils.format(etadateTime, "yyyy-MM-dd HH:mm:ss");


                request = {
                    eta: etadateTime,
                    etastr: String(formattedETADate),
                    // showETA: showETA,
                    transferId: transferid
                };
            }
            else{
                request = {
                    eta: null,
                    etastr: '',
                    // showETA: showETA,
                    transferId: transferid
                };
            }
            const res = await api.UpdateETA("", request);
            if (!res.hasError) {
                setetaTime(_etaTime)
                getScheduleTransferDetails();
                setLoading(false);
                setIsSubmitting(false);
                onClose()
            }
            else {
                setErrorMessage(res?.message)
                setLoading(false);
                setIsSubmitting(false);
            }
        } catch (error) {
            setErrorMessage("An error has occurred. Please try again.");
            setLoading(false);
            setIsSubmitting(false);
        }
    }

    const handleClose = () => {
        onClose()
    }

    const OnChangeRadio = () => {
        setETA("")
        setETADay("")
        const data = getValues()
        setValue('showETA', data?.showETA == "1" ? "2" : "1")
        if(data?.showETA == "2")
        {
            setETADay(dateUtil.format(new Date(), "yyyy-MM-dd"));
        }
        
    }

    return (
        <ThemeProvider theme={theme}>
            {open && (
                <Dialog
                    open={open}
                    onClose={handleClose}
                    classes={{ paper: classes.dialogPaper }}
                    fullWidth
                >
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <DialogTitle className={classes.dialogTitle} disableTypography>
                            Estimated Time of Arrival (For Pickup)
                            <ClearIcon className="closeIcon" onClick={handleClose} />
                        </DialogTitle>
                        <DialogContent className={classes.dialogContent}>
                            <Grid container spacing={3} className={"formContainer"}>
                                <Grid item xs={12}>
                                    <Controller
                                        control={control}
                                        name="showETA"
                                        defaultValue={"1"}
                                        rules={{
                                            required: "The field is required"
                                        }}
                                        render={(props) => (
                                            <FormControl fullWidth error={errors.showETA}>
                                                <RadioGroup {...props} className={classes.radioInput} onChange={OnChangeRadio}>
                                                    <FormControlLabel
                                                        control={<Radio size="small" />}
                                                        className="radioOption"
                                                        label="Show an ETA"
                                                        value="1"
                                                    />
                                                    {props.value === "1" && (
                                                        <Grid container spacing={2} className={"etaFields"}>
                                                            <Grid item xs={5}>
                                                                <Controller
                                                                    control={control}
                                                                    name="etaTime"
                                                                    defaultValue={eta && !isNaN(Date.parse(eta)) ? new Date(eta) : new Date()}
                                                                    rules={{
                                                                        required: "The field is required",
                                                                        validate: (value) => {
                                                                            const currentHours = new Date().getHours();
                                                                            const currentMinutes = new Date().getMinutes();
                                                                            const selectedDay = getValues("etaDay");
                                                                            if (selectedDay) {
                                                                                const selectedDate = new Date(selectedDay).getDate();
                                                                                const currentDate = new Date().getDate();
                                                                                if (selectedDate !== currentDate) {
                                                                                    return true;
                                                                                }
                                                                            }
                                                                            const selectedHours = new Date(value).getHours();
                                                                            const selectedMinutes = new Date(value).getMinutes();
                                                                            let output = false;
                                                                            if (selectedHours == currentHours) {
                                                                                if (selectedMinutes >= currentMinutes)
                                                                                    output = true;
                                                                                else
                                                                                    output = false;
                                                                            }
                                                                            else if (selectedHours >= currentHours) {
                                                                                output = true;
                                                                            }
                                                                            return output || "";
                                                                        },
                                                                    }}
                                                                    render={(props) => (
                                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                            <TimeInput
                                                                                {...props}
                                                                                inputVariant="outlined"
                                                                                value={eta && !isNaN(Date.parse(eta)) ? new Date(eta) : new Date() ?? props.value}
                                                                                className={"timeFieldInput"}
                                                                                format="HH:mm"
                                                                                placeholder="HH:MM"
                                                                                autoOk={true}
                                                                                cancelLabel={false}
                                                                                okLabel={false}
                                                                                onChange={(date) => {
                                                                                    if(date && !isNaN(Date.parse(date.toString())))
                                                                                    {
                                                                                        props.onChange(date);
                                                                                        setETA(String(date))
                                                                                    }
                                                                                }}
                                                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                                                error={errors.etaTime}
                                                                                helperText={errors.etaTime ? errors.etaTime.message : ''}
                                                                                keyboardIcon={<TimeIcon style={{ color: "#303030", fontSize: "22px" }} />}
                                                                            />
                                                                        </MuiPickersUtilsProvider>
                                                                    )}
                                                                />

                                                            </Grid>
                                                            <Grid item xs={7}>
                                                                <Controller
                                                                    control={control}
                                                                    name="etaDay"
                                                                    defaultValue={ETADay}
                                                                    rules={{
                                                                        required: "The field is required",
                                                                    }}
                                                                    render={(props) => (
                                                                        <FormControl fullWidth error={errors.etaDay}>
                                                                            <Select
                                                                                {...props}
                                                                                onChange={(e: any) => {
                                                                                    props.onChange(e);
                                                                                    setETADay(e?.target?.value)
                                                                                }}
                                                                                fullWidth
                                                                                value={ETADay ?? props.value}  
                                                                                variant="outlined"
                                                                                className={classes.selectField}
                                                                                IconComponent={KeyboardArrowDownIcon}
                                                                                displayEmpty
                                                                            >
                                                                                {/* <MenuItem key="None" value={""}>
                                                                                    Choose Day
                                                                                </MenuItem> */}
                                                                                {days.map((day: any, index: number) => {
                                                                                    return (
                                                                                        <MenuItem selected={day.selected} key={day.date} value={day.date}>
                                                                                            {day.name}
                                                                                        </MenuItem>
                                                                                    );
                                                                                })}
                                                                            </Select>
                                                                            <FormHelperText>{errors.etaDay ? errors.etaDay.message : ""}</FormHelperText>
                                                                        </FormControl>
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    )}

                                                    {(errors.etaTime) && (
                                                        <div style={{ color: "#F44A3D", marginBottom: 5 }}>Please select a valid date and time and not in the past.</div>
                                                    )}

                                                    <FormControlLabel
                                                        control={<Radio size="small" />}
                                                        className="radioOption"
                                                        label="Don’t show an ETA"
                                                        value="2"
                                                    />
                                                </RadioGroup>
                                                <FormHelperText>{errors.showETA ? errors.showETA.message : ''}</FormHelperText>
                                            </FormControl>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        {errorMessage && (<div style={{ paddingLeft: 25, paddingRight: 25, }}>
                            <div className={classes.headingAlert}>
                                <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                    {errorMessage}
                                </Alert>
                            </div>
                        </div>)}

                        {loading && (<div style={{ paddingTop: 10, paddingBottom: 10 }}>
                            {loading ? <CreateLoadingLine /> : null}
                        </div>)}
                        <DialogActions className={classes.dialogActions}>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <Button type="button" className={`${classes.button} cancelBtn`} onClick={handleClose}>
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button type="submit" className={`${classes.button} submitBtn`} disabled={isSubmitting}>
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </form>
                </Dialog>
            )}
        </ThemeProvider>
    )
}

export default ETAPopup;
